<template>
    <div>
        <!-- Content Header (Page header) -->
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0 text-dark"><i class="nav-icon fas fa-user-unlock"></i> Perfil de Usuários <small>Formulário de Cadastro</small></h1>
                    </div>
                    <!-- /.col -->
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <router-link to="/dashboard">
                                    <i class="nav-icon fas fa-home"></i> Home
                                </router-link>
                            </li>
                            <li class="breadcrumb-item active"><i class="nav-icon fas fa-user-unlock"></i> Perfil de Usuários</li>
                        </ol>
                    </div>
                    <!-- /.col -->
                </div>
                <!-- /.row -->
            </div>
            <!-- /.container-fluid -->
        </div>
        <!-- /.content-header -->
        <!-- Main content -->
        <section class="content">
            <div class="container-fluid">
                <div class="card card-primary card-outline">
                    <form id="form1" class="form-horizontal">
                        <div class="card-header">
                            <h3 class="card-title">Dados do Perfil de Usuário</h3>
                        </div>
                        <div class="card-body">
                            <div class="col-xs-12 col-sm-12 col-lg-6">
                                <div class="form-group row">
                                    <label for="nome_grupo" class="col-sm-2 col-form-label">Nome do Perfil</label>
                                    <div class="col-sm-10">
                                        <input type="text" class="form-control validate[required]" id="nome_grupo" name="nome_grupo" v-model="entity.nome_grupo" size="50" maxlength="150" placeholder="Nome do Perfil" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="descricao_grupo" class="col-sm-2 col-form-label">Descrição</label>
                                    <div class="col-sm-10">
                                        <textarea class="form-control " id="descricao_grupo" name="descricao_grupo" v-model="entity.descricao_grupo"  placeholder="Descrição" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="tipo_grupo" class="col-sm-2 col-form-label">Tipo de Perfil</label>
                                    <div class="col-sm-10">
                                        <select-editor v-model="entity.tipo_grupo" data-placeholder="Escolha o Tipo de Perfil">
                                            <option value="A">Administrador</option>
                                            <option value="R">Restrito</option>
                                        </select-editor>
                                    </div>
                                </div>
                                <div class="form-group row" v-if="entity.tipo_grupo == 'R'">
                                    <table class="table card-table offset-md-2 col-sm-10">
                                      <tbody>
                                        <tr>
                                          <th>Permissões</th>
                                          <th class="text-center py-0">Read</th>
                                          <th class="text-center py-0">Write</th>
                                          <th class="text-center py-0">Create</th>
                                          <th class="text-center py-0">Delete</th>
                                        </tr>
                                        <tr v-for="p in permissoes" :key="p.pagina">
                                          <td>{{p.pagina}}</td>
                                          <td class="text-center py-0">
                                            <span :class="[p.read ? 'fa fa-check text-primary' : 'fa fa-times text-danger']" v-on:click="p.read = !p.read" style="cursor: pointer;"></span>
                                          </td>
                                          <td class="text-center py-0">
                                            <span :class="[p.write ? 'fa fa-check text-primary' : 'fa fa-times text-danger']" v-on:click="p.write = !p.write" style="cursor: pointer;"></span>
                                          </td>
                                          <td class="text-center py-0">
                                            <span :class="[p.create ? 'fa fa-check text-primary' : 'fa fa-times text-danger']" v-on:click="p.create = !p.create" style="cursor: pointer;"></span>
                                          </td>
                                          <td class="text-center py-0">
                                            <span :class="[p.delete ? 'fa fa-check text-primary' : 'fa fa-times text-danger']" v-on:click="p.delete = !p.delete" style="cursor: pointer;"></span>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                </div>

                                <h4>Status</h4>
                                <div class="form-group row">
                                    <label class="col-sm-2 col-form-label"></label>
                                    <div class="col-sm-10">
                                        <div class="radio">
                                            <label class="form-radio form-icon">
                                                <input type="radio" name="status_usuario_grupo" data-icheck="green" v-model="entity.status_usuario_grupo" v-bind:value="true" />
                                                Ativo
                                            </label>
                                            <label class="form-radio form-icon">
                                                <input type="radio" name="status_usuario_grupo" data-icheck="red" v-model="entity.status_usuario_grupo" v-bind:value="false" />
                                                Inativo
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="card-footer">
                        <div class="offset-sm-1 col-sm-11">
                            <button type="button" v-if="this.$route.params.id == 0" v-on:click="insertEntity" class="btn btn-success btn-social"> <i class="fas fa-check"></i> Inserir</button>
                            <button type="button" v-if="this.$route.params.id != 0" v-on:click="updateEntity" class="btn btn-info btn-social"> <i class="fas fa-pencil-alt"></i> Alterar</button>
                            <button type="button" v-if="this.$route.params.id != 0" v-on:click="deleteEntity" class="btn btn-danger btn-social"> <i class="fas fa-times"></i> Excluir</button>
                            <button type="button" v-on:click="back" class="btn btn-default btn-social"><i class="fas fa-history"></i> Voltar</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>
        <!-- /.content -->
    </div>
</template>

<script>
    import UsuarioGrupoController from "@/controllers/usuario_grupo.controller";

    export default {
        data: function () {
            return {
                entity: {},
                permissoes: [
                    {id: "prestadores", pagina: "Prestadores", read: false, write: false, create: false, delete: false},
                    {id: "comissoes", pagina: "Comissões", read: false, write: false, create: false, delete: false}
                ]
            };
        },
        mounted() {
            this.$validator.validate("#form1");
            const id = parseInt(this.$route.params.id, 10);
            this.loadEntity(id);
            $(":input").inputmask();
        },
        methods: {
            loadEntity: function (id) {

                if (id === 0)
                    return;

                let vm = this;

                UsuarioGrupoController.getById(id)
                    .then(response => {
                        vm.entity = response.data.result;

                        if(vm.entity.permissoes) {
                            var json = JSON.parse(vm.entity.permissoes);

                            json.forEach(async (per) => {
                                const index = vm.permissoes.findIndex(x => x.id == per.id)

                                if(index !== -1){
                                    var p = vm.permissoes[index];
                                    p.read = per.read;
                                    p.create = per.create;
                                    p.write = per.write;
                                    p.delete= per.delete;
                                }
                            });
                        }
                    });
            },
            insertEntity: function (event) {
                if (!this.$validator.isValid("#form1"))
                return;

                event.target.disabled = true;

                let vm = this;

                vm.entity.permissoes = JSON.stringify(vm.permissoes);

                UsuarioGrupoController.insert(vm.entity)
                    .then(response => {
                        if (!response.data.success) {
                            vm.$toastr.error(response.data.error, 'Erro!', {
                                timeOut: 8000,
                                onHidden: function () {
                                    event.target.disabled = false;
                                }
                            });
                            return;
                        }

                        vm.$toastr.success("Dados cadastrados com sucesso.", "Aviso",
                            {
                                onHidden: function () {
                                    event.target.disabled = false;
                                    vm.back();
                                }
                            }
                        );
                    })
                    .catch(e => {
                        event.target.disabled = false;
                        vm.$toastr.error(e, 'Erro!', { timeOut: 8000 });
                    });
            },
            updateEntity: function (event) {
                if (!this.$validator.isValid("#form1"))
                return;

                event.target.disabled = true;

                let vm = this;

                vm.entity.permissoes = JSON.stringify(vm.permissoes);

                UsuarioGrupoController.update(vm.entity)
                    .then(response => {
                        if (!response.data.success) {
                            vm.$toastr.error(response.data.error, 'Erro!', {
                                timeOut: 8000,
                                onHidden: function () {
                                    event.target.disabled = false;
                                }
                            });
                            return;
                        }

                        vm.$toastr.success("Dados alterados com sucesso.", "Aviso",
                            {
                                onHidden: function () {
                                    event.target.disabled = false;
                                    vm.back();
                                }
                            });
                    })
                    .catch(e => {
                        event.target.disabled = false;
                        vm.$toastr.error(e, 'Erro!', { timeOut: 8000 });
                    });
            },
            deleteEntity: function (event) {
                event.target.disabled = true;

                let vm = this;

                vm.$dialogs.confirm({
                    title: 'Confirmar Exclusão!',
                    content: 'Deseja realmente excluir estes dados?',
                    icon: 'fa fa-exclamation-triangle ',
                    type: 'red',
                    buttons: {
                        confirm: {
                            text: 'Confirmar',
                            btnClass: 'btn-red',
                            action: function () {
                                event.target.disabled = true;

                                UsuarioGrupoController.delete(vm.entity)
                                    .then(response => {

                                        if (!response.data.success) {
                                            vm.$toastr.error(response.data.error, 'Erro!', {
                                                timeOut: 8000,
                                                onHidden: function () {
                                                    event.target.disabled = false;
                                                }
                                            });
                                            return;
                                        }

                                        vm.$toastr.success("Dados excluídos com sucesso.", "Aviso",
                                            {
                                                onHidden: function () {
                                                    vm.back();
                                                }
                                            }
                                        );
                                    })
                                    .catch(e => {
                                        vm.$toastr.error(e, 'Erro!', { timeOut: 8000 });
                                        event.target.disabled = false;
                                    });
                            }
                        },
                        close: {
                            text: 'Cancelar'
                        }
                    }
                });
                event.target.disabled = false;
            },
            back: function () {
                this.$router.push({ name: "list-usuario_grupo" });
            }
        }
    };
</script>

<style scoped>
</style>